/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Fields_MoreInputs */

const cs_templates_fields_more = /** @type {(inputs: Templates_Fields_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další pole`)
};

const en_templates_fields_more = /** @type {(inputs: Templates_Fields_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More fields`)
};

/**
* | output |
* | --- |
* | "More fields" |
*
* @param {Templates_Fields_MoreInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_fields_more = /** @type {((inputs?: Templates_Fields_MoreInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Fields_MoreInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_fields_more(inputs)
	return cs_templates_fields_more(inputs)
});